import { useEffect, useState } from "react";

const Defaults = {
  deferredTime: 1000,
};

export const useDeferred = (value, delayTime) => {
  const [val, setVal] = useState();
  let timeOutId = null;

  const cbDebounce = (cb) => {
    if (!!timeOutId) {
      clearTimeout(timeOutId);
    }

    timeOutId = setTimeout(() => {
      cb();
    }, delayTime || Defaults.deferredTime);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      setVal(value);
    }, delayTime || Defaults.deferredTime);

    return () => clearTimeout(delay);
  }, [value]);

  return { val, cbDebounce };
};
